export const DEFAULT_STEP_LABEL = 'Next';

export const DEFAULT_NEXT_ICON = 'arrow-right';

export const HEADER_TITLE = 'Add a job';

export const MODAL_ID = 'mobile-close-modal-id';
